import type { ISummaryItem } from "../../../../../pages/Summary/Summary.types";
import ScrollableTable from "../../../../shared/ScrollableTable/ScrollableTable";
import type { IEntrySelectValue } from "../Multiple.model";
import EntriesSelectListItem from "./EntriesSelectListItem";
import { useRef, useState, useCallback, memo } from "react";

interface Props {
  items: ISummaryItem[];
  toggleCollapse?: (index: number) => void;
  entries?: Record<string, any>[][];
  setSelectedEntries: (selectedEntries: IEntrySelectValue[]) => void;
  selectedEntries: IEntrySelectValue[];
  loading: boolean;
}

const EntriesSelectList = ({
  items,
  toggleCollapse,
  entries,
  selectedEntries,
  setSelectedEntries,
  loading,
}: Props) => {
  const [focusedRowIndex, setFocusedRowIndex] = useState<number>(-1);
  // const [lastArrowKey, setLastArrowKey] = useState<string | null>(null);
  const scrollableTableRef = useRef<HTMLDivElement>(null);
  // const animationFrameRef = useRef<number | null>(null);

  // const handleKeyDown = (event: KeyboardEvent) => {
  //   if (event.key === "ArrowDown") {
  //     // setLastArrowKey("ArrowDown");
  //     setFocusedRowIndex(prevIndex =>
  //       Math.min(prevIndex + 1, items.length - 1),
  //     );
  //   } else if (event.key === "ArrowUp") {
  //     // setLastArrowKey("ArrowUp");
  //     setFocusedRowIndex(prevIndex => Math.max(prevIndex - 1, 0));
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [items.length]);

  // useEffect(() => {
  //   if (scrollableTableRef.current && focusedRowIndex !== -1) {
  //     if (animationFrameRef.current) {
  //       cancelAnimationFrame(animationFrameRef.current);
  //     }
  //     animationFrameRef.current = requestAnimationFrame(() => {
  //       if (!scrollableTableRef.current) return;
  //       const rowElement = scrollableTableRef.current.querySelector(
  //         `tr:nth-child(${focusedRowIndex + 1})`,
  //       );
  //       if (rowElement) {
  //         rowElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  //       }
  //     });
  //   }
  // }, [focusedRowIndex]);

  const headers = [
    { label: "Show Entry" },
    { label: "Entry" },
    { label: "Opened" },
    { label: "Status" },
    { label: "Select" },
  ];
  if (!entries) {
    headers.splice(0, 1);
  }

  const renderRow = useCallback(
    ({ row, index }: { row: ISummaryItem; index?: number }) => {
      const sections =
        index !== undefined && entries && entries[index]
          ? entries[index]
          : undefined;
      return (
        index !== undefined && (
          <EntriesSelectListItem
            key={`entry-row-${index}`}
            index={index}
            sections={sections}
            {...row}
            toggleCollapse={toggleCollapse}
            selectedEntries={selectedEntries}
            setSelectedEntries={setSelectedEntries}
            isFocused={focusedRowIndex === index && false}
            setFocused={setFocusedRowIndex}
          />
        )
      );
    },
    [
      entries,
      toggleCollapse,
      selectedEntries,
      setSelectedEntries,
      focusedRowIndex,
    ],
  );

  return (
    <div style={{ width: "100%" }} ref={scrollableTableRef}>
      <ScrollableTable
        loading={loading}
        headers={headers}
        data={items}
        renderRow={renderRow}
        style={{
          maxHeight: entries ? "65vh" : "35vh",
          overflowY: "auto",
        }}
      />
    </div>
  );
};
export default memo(EntriesSelectList);
